<form class="w-[50vw] ml-[25vw] pt-[1vh]" [formGroup]="createTreatmentForm" (ngSubmit)="OnSubmit()">
  @if(!isOwnerSet){
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet.Owner'|translate}${'FieldRequiredMarker'|translate}` }}</div>
  <p-autocomplete id="owner" variant="filled" fluid="true" size="large"
                  formControlName="owner" [suggestions]="customersSuggestions"
                  (completeMethod)="filterCustomers($event)" [optionLabel]="getOptionLabelForOwner" (onSelect)="OnSelectCustomer($event)" [invalid]="isFormControlInvalid(createTreatmentForm.controls.owner, submitButtonClicked)">
    <ng-template let-owner #selectedItem>
      <div>{{ owner.firstName }} {{ owner.lastName }}, {{ owner.street }} {{ owner.houseNumber }}
        , {{ owner.postalCode }} {{ owner.city }}, {{ owner.country }}
      </div>
    </ng-template>
    <ng-template let-owner #item>
      <div>{{ owner.firstName }} {{ owner.lastName }}, {{ owner.street }} {{ owner.houseNumber }}
        , {{ owner.postalCode }} {{ owner.city }}, {{ owner.country }}
      </div>
    </ng-template>
  </p-autocomplete>
  }
  @if(!isPetSet){
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ `${'Pet'|translate}${'FieldRequiredMarker'|translate}` }}</div>
  <p-select id="pet" variant="filled" fluid="true" size="large"
                  formControlName="pet" [options]="petsSuggestions" optionLabel="nickname"
                  [invalid]="isFormControlInvalid(createTreatmentForm.controls.pet, submitButtonClicked)">
  </p-select>
  }
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start  mt-[1vh]"> {{ `${'Treatment.Title'|translate}${'FieldRequiredMarker'|translate}`}}</div>
  <input id="insuranceProvider" type="text" variant="filled" fluid="true" pInputText pSize="large"
         formControlName="title" [invalid]="isFormControlInvalid(createTreatmentForm.controls.title, submitButtonClicked)"/>
    <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start  mt-[1vh]"> {{ `${'Treatment.AppointmentDate'|translate}${'FieldRequiredMarker'|translate}`}}</div>
    <p-datepicker id="appointmentDate" variant="filled" fluid="true" size="large" formControlName="appointmentDate" showIcon iconDisplay="input" [showTime]="true" [stepMinute]="15" [invalid]="isFormControlInvalid(createTreatmentForm.controls.appointmentDate, submitButtonClicked)"></p-datepicker>
  <div class="pl-[0.25vw] pb-[0.5vh] text-l self-start mt-[1vh]"> {{ 'TreatmentDescription'|translate }}</div>
  <p-editor formControlName="description" [style]="{ height: '30vh' }">
    <ng-template #header>
                <span class="ql-formats">
                  <button type="button" class="ql-bold" aria-label="Bold"></button>
                  <button type="button" class="ql-italic" aria-label="Italic"></button>
                  <button type="button" class="ql-underline" aria-label="Underline"></button>
                  <button type="button" class="ql-strike" aria-label="Strike"></button>
                  <span class="ql-formats">
                    <select class="ql-color" aria-label="Color">
                      <option selected></option>
                      <option value="red"></option>
                      <option value="blue"></option>
                      <option value="yellow"></option>
                      <option value="white"></option>
                    </select>
                  </span>
                  <span class="ql-formats">
                    <select class="ql-size" aria-label="Size">
                      <option selected></option>
                      <option value="small"></option>
                      <option value="large"></option>
                      <option value="huge"></option>
                    </select>
                  </span>
                </span>
    </ng-template>
  </p-editor>
  <div class="flex justify-around mt-[3vh]">
    <p-button type="submit" size="large"
              label="{{'CreateTreatment.Save'|translate}}"/>
  </div>
</form>
